import {
  ChangeDetectorRef, Component, Output, EventEmitter, ViewChild,
} from '@angular/core';
import * as _ from 'lodash';

import { SendBillingFormComponent } from './send-billing-form/send-billing-form.component';
import { BaseModalComponent } from '../../modal/_base-modal.component';
import { sendBillingData } from './send-billing-data';
import { LoaderComponent } from '../../loader/loader.component';


@Component({
  moduleId: module.id,
  selector: 'send-billing-modal',
  templateUrl: 'send-billing-modal.component.html',
  styleUrls: ['send-billing-modal.component.scss'],
})
export class SendBillingModalComponent extends BaseModalComponent {

  processing: boolean = false;

  sendBillingData: any = sendBillingData;

  error: string;

  @Output() submit = new EventEmitter();

  @ViewChild(SendBillingFormComponent, {static: false}) sendBillingForm: SendBillingFormComponent | void;

  @ViewChild('sendBillingModalLoader', {static: false}) loader: LoaderComponent | void;

  constructor(
    private ref: ChangeDetectorRef,
  ) {
    super();
  }

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/
  get form() {
    return this.sendBillingForm && this.sendBillingForm.form;
  }

  get isActionsAvailable() {
    return this.form ? this.form.valid : false;
  }

  /*******************************************
   * COMPONENT PUBLIC METHODS
   *******************************************/

  public show() {
    this.clearData();
    super.show();
  }

  public hide() {
    if (this.sendBillingForm) {
      this.sendBillingForm.clearForm();
    }
    super.hide();
  }

  public showLoader() {
    if (this.loader) {
      this.loader.show();
    }
    this.processing = true;
    this.ref.markForCheck();
  }

  public hideLoader() {
    if (this.loader) {
      this.loader.hide();
    }
    this.processing = false;
    this.ref.markForCheck();
  }

  public setError(error: string) {
    this.error = error;
    this.ref.markForCheck();
  }

  /*******************************************
   * COMPONENT HANDLERS
   *******************************************/

  onSendClick() {
    if (!this.isActionsAvailable) { return; }

    this.submit.emit({
      emails: this.form.controls['emails'].value,
      ccs: this.form.controls['ccs'].value,
      bccs: this.form.controls['bccs'].value,
      subject: this.form.controls['subject'].value,
      body: this.form.controls['body'].value,
    });
  }

  onFormDataChanged() {
    this.error = undefined;
    this.ref.markForCheck();
  }

  /*******************************************
   * COMPONENT PRIVATE METHODS
   *******************************************/

  private clearData() {
    this.processing = false;
    this.error = undefined;
    this.ref.markForCheck();
  }
}
